export default __webpack_public_path__ + "a53094ba3b8e7bc1ff1501a25a93b5e0.svg";